var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomBarBellBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.30298 16.0236C8.71957 15.9355 11.2581 15.9355 11.6747 16.0236C12.0308 16.1058 12.4159 16.298 12.4159 16.7177C12.3952 17.1172 12.1608 17.4714 11.837 17.6963C11.4171 18.0236 10.9243 18.2309 10.4091 18.3056C10.1242 18.3426 9.84429 18.3434 9.56932 18.3056C9.05334 18.2309 8.56055 18.0236 8.14147 17.6955C7.81681 17.4714 7.58243 17.1172 7.56172 16.7177C7.56172 16.298 7.94684 16.1058 8.30298 16.0236ZM10.038 1.66699C11.7715 1.66699 13.5422 2.48951 14.594 3.85421C15.2765 4.73296 15.5896 5.61087 15.5896 6.97558V7.3306C15.5896 8.37721 15.8662 8.9941 16.4749 9.70498C16.9362 10.2287 17.0837 10.901 17.0837 11.6303C17.0837 12.3589 16.8443 13.0504 16.3648 13.6119C15.737 14.2851 14.8516 14.7148 13.948 14.7895C12.6386 14.9011 11.3284 14.9951 10.0007 14.9951C8.67228 14.9951 7.36287 14.9389 6.05345 14.7895C5.14904 14.7148 4.26367 14.2851 3.63671 13.6119C3.15718 13.0504 2.91699 12.3589 2.91699 11.6303C2.91699 10.901 3.06524 10.2287 3.52573 9.70498C4.15352 8.9941 4.41193 8.37721 4.41193 7.3306V6.97558C4.41193 5.57394 4.76143 4.65742 5.48115 3.76021C6.55121 2.45174 8.26645 1.66699 9.96347 1.66699H10.038Z",
    fill: "#310048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomBarBellBlack);
export default __webpack_public_path__ + "static/media/bottom-bar-bell-black.e2d720c54e174ef756470e3f80ae08c0.svg";
export { ForwardRef as ReactComponent };